import { writable, get } from "svelte/store";

export type Mode = "live" | "demo"
export const initStore = () => writable<Mode>("live");
export const modeStore = initStore();

export const set = (mode: Mode) => modeStore.set(mode);
export const isDemo = () => get(modeStore) === "demo";
